import React from 'react';

import CopyrightIcon from '@mui/icons-material/Copyright';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { showLocation, getPricingDetails, handleKeyDown, isEventTypeWebinar } from '@common/Util';

import Content from './components/Content';
import Footer from './components/Footer';

const PlainCardContentImage = styled(CardMedia)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.common.white,
  backgroundRepeat: 'no-repeat',
  height: '127px',
  objectFit: 'cover'
}));

const StyledCard = styled(Card)(({ theme }) => ({
  outline: 'none',
  height: '24em',
  marginBottom: 2,
  cursor: 'pointer',
  position: 'relative',
  bottom: 0,
  transition: 'bottom 0.1s',
  '&:hover': {
    bottom: '2px'
  },
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
    borderRadius: theme.shape.borderRadius
  }
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  color: theme.palette.grey[100],
  paddingLeft: '5px',
  width: '100%',
  textAlign: 'left',
  lineHeight: 1
}));

const EventGridItem = ({
  event,
  onItemClick = () => {},
  config,
  memoizedImageSource,
  label,
  showMaxSeats = () => {}
}) => {
  const { eventPrice, eventCurrency } = getPricingDetails(event);

  const handleKey = (e) => {
    handleKeyDown(e, event, onItemClick);
  };

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} key={event.id}>
      <StyledCard
        data-test-id='eventItemContent'
        tabIndex={0}
        onClick={() => onItemClick(event)}
        onKeyDown={handleKey}
      >
        <PlainCardContentImage
          sx={{ height: '40%' }}
          component='img'
          src={memoizedImageSource}
          alt={label}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '60%'
          }}
        >
          {event?.copyrightInfo && (
            <StyledBox>
              <CopyrightIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
              <Typography sx={{ fontSize: '0.75rem' }}>{event?.copyrightInfo}</Typography>
            </StyledBox>
          )}
          <Content
            startDate={event?.startDateTime}
            endDate={event?.endDateTime}
            eventTypeName={event?.type?.value}
            eventName={event?.name}
            config={config}
            languages={event?.nativeLanguages}
            price={eventPrice || ''}
            currency={eventCurrency}
            event={event}
          />

          {/* Footer */}
          {config?.footer && (
            <Footer
              city={!isEventTypeWebinar(event) && event?.venues[0]?.city}
              price={eventPrice || ''}
              currency={eventCurrency}
              country={!isEventTypeWebinar(event) && event?.venues[0]?.country}
              config={config}
              participantStatus={event?.eventParticipant?.status}
              location={`${showLocation(event)}`}
              maxSeats={showMaxSeats(event?.availableSeats, event?.maxParticipants)}
            />
          )}
        </Box>
      </StyledCard>
    </Grid>
  );
};

export default EventGridItem;
